import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import DropdownIcon from '@material-ui/icons/ArrowDropDown';
import { useObserver } from 'mobx-react-lite';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navButton: {
      textTransform: 'none',
      fontWeight: 'bold'
    }
  })
);

function FaroServicesMenuButton(props: RouteComponentProps) {
  const { history } = props;

  const classes = useStyles({});
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);

  function onShowParameterSets() {
    onMenuClose();
    history.push('/faro/parameters');
  }

  function onShowDecks() {
    onMenuClose();
    history.push('/faro/decks');
  }

  function onShowDeployments() {
    onMenuClose();
    history.push('/faro/deployments');
  }

  function onMenuOpen(event: React.MouseEvent<HTMLButtonElement>) {
    setMenuAnchorEl(event.currentTarget);
  }

  function onMenuClose() {
    setMenuAnchorEl(null);
  }

  return useObserver(() => (
    <div>
      <Button color="inherit" className={classes.navButton} onClick={onMenuOpen}>Faro Services <DropdownIcon /></Button>
      <Menu
        id="faro-services-menu"
        anchorEl={menuAnchorEl}
        keepMounted
        open={Boolean(menuAnchorEl)}
        onClose={onMenuClose}
      >
        <MenuItem onClick={onShowParameterSets}>Parameter Sets</MenuItem>
        <MenuItem onClick={onShowDecks}>Decks</MenuItem>
        <MenuItem onClick={onShowDeployments}>Deployments</MenuItem>
      </Menu>
    </div >
  ));
};

export default withRouter(FaroServicesMenuButton);
